module.exports = ".brand {\n  -ms-flex-line-pack: rigth;\n      align-content: rigth; }\n\n.align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-ejemplo/master-ejemplo.component.scss
// module id = ./src/app/master/master-ejemplo/master-ejemplo.component.scss
// module chunks = main